import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { EmployeeCreatePage } from '@/features/org/components/employee-form-page'
import { EMPLOYEES_SEARCH_DEFAULTS, employeesSearchSchema } from '@/features/org/search-schema'

/**
 * /employees/new —— 新建员工。
 *
 * 刻意是**独立路由页**而不是列表上的弹窗:URL 可分享、冷加载可还原、浏览器后退即取消(A4 纪律)。
 * 复用列表的 search schema —— 表单页把用户来时的筛选原样带着,提交完 / 取消都回到同一屏列表。
 */
export const Route = createFileRoute('/_authed/employees/new')({
  validateSearch: employeesSearchSchema,
  search: {
    middlewares: [stripSearchParams(EMPLOYEES_SEARCH_DEFAULTS)],
  },
  component: EmployeeCreatePage,
})
